import { render, staticRenderFns } from "./add-room-dialog.vue?vue&type=template&id=486d924a&"
import script from "./add-room-dialog.vue?vue&type=script&lang=js&"
export * from "./add-room-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports